/* Custom Couple Woven Blanket — PDP enhancements.
 * 1. Per-design personalization fields (show/hide + disable hidden inputs).
 * 2. Instant price + compare-at update on Size/Design change (no network wait —
 *    Shrine's own section re-render still runs and lands on identical values).
 * 3. Instant add-to-cart feedback: loading state + optimistic drawer open.
 * Progressive enhancement only — if any hook is missing, everything no-ops.
 */
(function () {
  "use strict";

  var wrap = document.querySelector(".ccwb-personalize");

  /* ---------- 1. Design-aware personalization fields ---------- */
  var fieldMap = {};
  if (wrap) {
    try {
      fieldMap = JSON.parse(wrap.getAttribute("data-field-map") || "{}");
    } catch (e) {
      fieldMap = {};
    }
  }

  function selectedOption(optionName) {
    var checked = document.querySelector(
      'input[type="radio"][name="' + optionName + '"]:checked',
    );
    if (checked) return checked.value;
    var select = document.querySelector(
      'select[name="options[' + optionName + ']"]',
    );
    return select ? select.value : null;
  }

  var fieldCopy = {};
  if (wrap) {
    try {
      fieldCopy = JSON.parse(wrap.getAttribute("data-field-copy") || "{}");
    } catch (e) {
      fieldCopy = {};
    }
  }

  var defaultCopy = {
    name1: ["First name", "e.g. Sophie"],
    name2: ["Second name", "e.g. Daniel"],
    place: ["City or place", "e.g. London"],
    date: ["Date", "e.g. 12 May 2019"],
    year: ["Est. year", "e.g. 2022"],
    milestone: ["Milestone line", "e.g. 10 Wonderful Years"],
    message: ["Message", "e.g. My favourite person, always"],
  };

  function applyFields() {
    if (!wrap) return;
    var design =
      selectedOption("Design") || wrap.getAttribute("data-selected-design");
    var visible = fieldMap[design] || ["name1", "name2", "date"];
    var copy = fieldCopy[design] || {};
    wrap.querySelectorAll(".ccwb-personalize__field").forEach(function (el) {
      var key = el.getAttribute("data-field");
      var show = visible.indexOf(key) !== -1;
      el.hidden = !show;
      var pair = copy[key] || defaultCopy[key];
      var label = el.querySelector(".ccwb-personalize__label");
      var input = el.querySelector("input");
      if (pair && label && input) {
        /* first child is the text node; keep the required asterisk span intact */
        if (label.childNodes.length && label.childNodes[0].nodeType === 3) {
          label.childNodes[0].nodeValue = pair[0] + " ";
        } else {
          label.textContent = pair[0];
        }
        input.placeholder = pair[1];
      }
      el.querySelectorAll("input").forEach(function (inp) {
        inp.disabled = !show; /* disabled inputs are not submitted */
      });
    });
  }

  /* ---------- 2. Instant price update ---------- */
  var variants = [];
  var dataEl = document.querySelector(".ccwb-variant-data");
  if (dataEl) {
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      variants = [];
    }
  }

  function instantPrice() {
    if (!variants.length) return;
    var design = selectedOption("Design");
    var size = selectedOption("Size");
    if (!design || !size) return;
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].o1 === design && variants[i].o2 === size) {
        v = variants[i];
        break;
      }
    }
    if (!v) return;
    document
      .querySelectorAll(".price-item--sale.main-price")
      .forEach(function (el) {
        el.textContent = v.price;
      });
    document.querySelectorAll(".main-comapre-price").forEach(function (el) {
      el.textContent = v.compare;
    });
  }

  /* ---------- 3. Instant add-to-cart feedback ---------- */
  function optimisticAtc(form) {
    var btn = form.querySelector('button[name="add"]');
    if (btn && !btn.classList.contains("loading")) {
      btn.classList.add("loading");
      var spinner = btn.querySelector(".loading-overlay__spinner");
      if (spinner) spinner.classList.remove("hidden");
    }
    var drawer = document.querySelector("cart-drawer");
    if (drawer && !drawer.classList.contains("active")) {
      drawer.classList.add("animate", "active");
      document.body.classList.add("overflow-hidden");
    }
  }

  /* ---------- wiring ---------- */
  document.addEventListener("change", function (e) {
    var name = e.target && e.target.name;
    if (name === "Design") {
      applyFields();
      instantPrice();
    } else if (name === "Size") {
      instantPrice();
    }
  });

  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (
        form &&
        form.getAttribute &&
        (form.getAttribute("action") || "").indexOf("/cart/add") !== -1 &&
        (form.id || "").indexOf("product-form-") === 0
      ) {
        if (!form.checkValidity()) {
          /* Shrine forms are novalidate — enforce required personalization */
          e.preventDefault();
          e.stopImmediatePropagation();
          form.reportValidity();
          return;
        }
        optimisticAtc(form);
      }
    },
    true,
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyFields);
  } else {
    applyFields();
  }
})();

/* ---------- 4. Size proxy cards -> hidden native Size radios ---------- */
(function () {
  'use strict';

  function nativeSizeRadio(value) {
    var radios = document.querySelectorAll(
      'variant-selects input[type="radio"][name="Size"]'
    );
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) return radios[i];
    }
    return null;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.name) return;

    /* proxy card clicked -> drive the hidden native radio */
    if (t.name.indexOf('ccwb-size-proxy') === 0) {
      var real = nativeSizeRadio(t.value);
      if (real && !real.checked) real.click();
      var wrap = t.closest('[data-ccwb-size-proxy]');
      if (wrap) {
        wrap.querySelectorAll('.ccwb-size__option').forEach(function (el) {
          el.classList.toggle(
            'is-selected',
            el.contains(t) && t.checked
          );
        });
      }
    }

    /* native Size changed elsewhere (e.g. sticky ATC) -> sync proxy UI */
    if (t.name === 'Size') {
      document.querySelectorAll('[data-ccwb-size-proxy]').forEach(function (wrap) {
        wrap.querySelectorAll('.ccwb-size__input').forEach(function (input) {
          var on = input.value === t.value;
          input.checked = on;
          input.closest('.ccwb-size__option').classList.toggle('is-selected', on);
        });
      });
    }
  });
})();

/* ---------- 5. Sticky ATC must respect required personalization ---------- */
(function () {
  'use strict';
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest &&
        e.target.closest('button[id^="SectionAtcBtn-"], button[id^="ProductSubmitButton-"], form[action*="/cart/add"] button[name="add"]');
      if (!btn) return;
      var formId = btn.getAttribute('form');
      var form = (formId && document.getElementById(formId)) || btn.closest('form[action*="/cart/add"]');
      if (form && !form.checkValidity()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        form.reportValidity(); /* focuses + scrolls to the missing field */
      }
    },
    true
  );
})();
